 /*
  * Factory to get json file for the teaser component 
  * json files should be located in the appropriate folder per site
  * json file should useing nameing convention teaser-{stateName}.json
  *
  */

 angular
    .module('vppApp')
    .factory('teaserFactory', teaserFactory);

    teaserFactory.$inject = ['$http', '$rootScope', 'vppConfig', '$state'];

    function teaserFactory($http, $rootScope, vppConfig, $state){
        return function(){
           var Url  = vppConfig.teaserContentPath + "teaser-" + $state.current.name + ".json";
         var promise = $http.get(Url).then(function(data){
          return data;

        }, function errorCallback (data){
          return data;
        });
         return promise;
        } 
  };